// componentes
import Hero from "../components/components-home/Hero";
import Header from "../components/components-home/header/Header";
import Abount from "../components/components-home/About";
import Services from "../components/components-home/Services";
import Portfolio from "../components/components-home/Portfolio";
import Team from "../components/components-home/Team";
import Contact from "../components/components-home/Contact";
import Footer from "../components/components-home/Footer";
import Social from "../components/components-home/Social";

import "./../assets/style/index.css";
import AnimationMouse from "../components/shared/AnimationMouse";
import ModalImag from "../components/shared/ModalImag";
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { scrollToSection } from "../utils/scrollToSection";
import { useDocumentMeta } from "../hooks/useDocumentMeta";

export default function App() {
  const location = useLocation();
  const navigate = useNavigate();

  // Sin título propio cae en el del index.html, que es justo el que queremos
  // para la portada. Lo que sí fija es el canónico en el dominio público y las
  // palabras por las que debe encontrarse el estudio, "Afrodita" incluida.
  useDocumentMeta({
    description:
      "Afrodita Models (Estudio Afrodita) es el estudio de modelaje webcam líder en Armenia, Quindío. Más de 4 años de experiencia, disponibilidad 24/7, entorno profesional y seguro, y pagos diarios en dólares.",
    canonical: "https://www.afroditamodels.com/",
    image: "https://www.afroditamodels.com/og-image.jpg",
    keywords: [
      "Afrodita",
      "Afrodita Models",
      "Afrodita Model",
      "Estudio Afrodita",
      "Afrodita Armenia",
      "Afrodita Quindío",
      "Afrodita webcam",
      "estudio webcam Armenia",
      "modelaje webcam Quindío",
      "trabajo webcam Colombia",
      "pagos diarios en dólares",
    ],
  });

  // Al llegar desde otra ruta pulsando "Nosotros", "Servicios", etc., el
  // destino viene en el state de la navegación. Se consume una sola vez: si
  // quedara guardado, recargar o volver atrás repetiría el desplazamiento.
  useEffect(() => {
    const target = location.state?.scrollTo;
    if (!target) return;

    scrollToSection(target);
    navigate(location.pathname, { replace: true, state: null });
  }, [location.state, location.pathname, navigate]);

  return (
    <>
      <Header />
      <Hero />
      <Abount />
      <Services />
      <Portfolio />
      <Team />
      <Contact />
      <Footer />
      <Social />
      <AnimationMouse/>
      <ModalImag/>
    </>
  );
}
